import DashboardLayout from '../components/DashboardLayout';
import Breadcrumb from '../components/partials/Breadcrumb';
import PriceCard from '../components/partials/PriceCard';
import { checkoutUrl } from '../constants/externalLinks';

export default function TrustsPage() {
  return (
    <DashboardLayout>
      <div
        className="pl-14 pr-4 py-5 md:px-10 md:py-8"
        style={{ maxWidth: 960 }}
      >
        <Breadcrumb current="Living Trusts for Crypto Holders" />

        {/* Hero */}
        <div className="dash-svc-hero">
          <div className="dash-svc-hero__inner">
            <p className="dash-svc-eyebrow">Living Trusts for Crypto Holders</p>
            <h1 className="dash-svc-title font-serif">
              Protect your family after you're gone
            </h1>
            <div className="dash-svc-lede">
              <p>
                You accumulated digital assets, held through volatility, and
                built something worth protecting. Maybe you even set up an LLC
                to shield your holdings from lawsuits and keep your name off
                public records.
              </p>
              <p>
                Your LLC protects your crypto while you're alive. A living trust
                protects your family after you're gone — most people set up one
                and forget the other, then their family spends 18 months in
                probate court anyway.
              </p>
              <p>
                DAG helps you set up a living trust through attorneys who
                specialize in estate planning. If you already have a Digital
                Asset LLC, we can assign the trust to it. If you don't have one
                yet, our full package creates both.
              </p>
            </div>
          </div>
        </div>

        {/* Pricing */}
        <p className="dash-svc-section-label">Create your living trust</p>
        <div className="dash-price-grid">
          <PriceCard
            name="Digital Asset Living Trust Formation"
            sub="Set up a living trust for your digital assets"
            amount="$500"
            terms="One-time fee"
            features={[
              'Attorney-drafted trust template, completed by you',
              'Digital asset provisions',
              'Beneficiary designations',
            ]}
            checkoutHref={checkoutUrl('digital-asset-living-trust')}
            ctaLabel="Get Started · $500"
            featured
            ctaGold
          />
          <PriceCard
            name="Living Trust Assignment Bridge"
            sub="Assign your existing LLC into a trust"
            amount="$500"
            terms="One-time fee"
            features={[
              'Assignment of LLC interest',
              'Trust funding documents',
              'Records updated',
            ]}
            checkoutHref={checkoutUrl('living-trust-assignment-bridge')}
            ctaLabel="Get Started · $500"
            featured
            ctaGold
          />
          <PriceCard
            badge="Best value"
            name="Living Trust Legacy Bundle"
            sub="Trust formation + LLC assignment together"
            amount="$1,000"
            terms="One-time fee"
            features={[
              'Everything in Formation',
              'Everything in Assignment Bridge',
              'Coordinated single engagement',
            ]}
            featured
            checkoutHref={checkoutUrl('living-trust-legacy-bundle')}
            ctaLabel="Get Started · $1,000"
            ctaGold
          />
          <PriceCard
            name="Trust & Estate Tax Preparation — Form 1041"
            sub="Fiduciary income tax return for your trust"
            amount="$500"
            terms="Per filing"
            features={[
              'Form 1041 preparation',
              'Schedule K-1s for beneficiaries',
              'Filed by our tax team',
            ]}
            checkoutHref={checkoutUrl('trust-estate-tax-1041')}
            ctaLabel="Get Started · $500"
            featured
            ctaGold
          />
        </div>
      </div>
    </DashboardLayout>
  );
}
